import React from 'react';

import { Box, Typography } from '@mui/material';
import ScrollableTooltipContent from '@sharedCR/common/ScrollableTooltipContent';
import PropTypes from 'prop-types';

import { fixedTwoFractionDigitsCurrencyOptions } from 'constants/loanApplication';
import { formatNumberToCurrencyString } from 'utils/number';

import { HOUSING_EXPENSE_TOTAL_LABEL, housingExpenseRows } from './HousingExpenseData.constants';
import { footerStyles, rowStyles, rowsWrapperStyles } from './HousingExpenseData.styles';

const HousingExpenseData = ({ data }) => (
  <ScrollableTooltipContent
    footer={
      <Box sx={footerStyles}>
        <Typography color="text.primary" variant="medium16">
          {HOUSING_EXPENSE_TOTAL_LABEL}
        </Typography>
        <Typography color="primary.main" variant="bold16">
          {formatNumberToCurrencyString(data.housingExpense, fixedTwoFractionDigitsCurrencyOptions)}
        </Typography>
      </Box>
    }
  >
    <Box sx={rowsWrapperStyles}>
      {housingExpenseRows.map(({ label, valueKey }) => (
        <Box key={valueKey} sx={rowStyles}>
          <Typography color="text.secondary" variant="regular14">
            {label}
          </Typography>
          <Typography color="text.primary" variant="medium16">
            {formatNumberToCurrencyString(data[valueKey], fixedTwoFractionDigitsCurrencyOptions)}
          </Typography>
        </Box>
      ))}
    </Box>
  </ScrollableTooltipContent>
);

HousingExpenseData.propTypes = {
  data: PropTypes.shape({
    piti: PropTypes.number.isRequired,
    monthlyLotRent: PropTypes.number.isRequired,
    landMonthlyPayment: PropTypes.number.isRequired,
    housingExpense: PropTypes.number.isRequired,
  }).isRequired,
};

export default HousingExpenseData;
